class StudyProgressConfig {
    constructor() {
        this.CONSENT_INTRO_PROGRESS_BY_PAGE_INDEX = {
            0: 0,  
            1: 3,  
            2: 6,  
            3: 12, 
            4: 18, 
            5: 21, 
            6: 24,
            7: 27
        };

        this.STUDY_ONE_COMPLETION_PROGRESS = 40;
        this.STUDY_TWO_PROCEDURE_INDEX_TO_PROGRESS_MAPPING = {
            0: 43,
            1: 53,
            2: 65,
            3: 92
        }

        this.STUDY_TWO_SESSION_ONE_INTRO_PROGRESS_BY_PAGE_INDEX = {
            0: this.STUDY_ONE_COMPLETION_PROGRESS,
            1: this.STUDY_TWO_PROCEDURE_INDEX_TO_PROGRESS_MAPPING[0]
        };

        this.STUDY_TWO_SESSION_TWO_INTRO_PROGRESS_BY_PAGE_INDEX = {
            0: this.STUDY_TWO_PROCEDURE_INDEX_TO_PROGRESS_MAPPING[1],
            1: 54,
            2: 56
        };

        this.STUDY_TWO_SESSION_ONWARD_INTRO_PROGRESS_BY_PAGE_INDEX = {
            0: this.STUDY_TWO_PROCEDURE_INDEX_TO_PROGRESS_MAPPING[2],
            1: 67,
            2: 70,
            3: 73,
            4: 80,
            5: 83,
            6: 87,
            7: 90,
            8: 95,
            9: 98,
            10: 100
        };

        this.STUDY_TWO_SUMMARY_PROGRESS_BY_PAGE_INDEX = {
            0: this.STUDY_TWO_PROCEDURE_INDEX_TO_PROGRESS_MAPPING[3],
            1: 95,
            2: 100
        };
    }

    getConsentAndStudyOneProgressByPageConfig () {
        return this.CONSENT_INTRO_PROGRESS_BY_PAGE_INDEX;
    }

    getStudyOneCompletionProgress(){
        return this.STUDY_ONE_COMPLETION_PROGRESS;
    }

    getStudyTwoSessionOneProgressByPageConfig () {
        return this.STUDY_TWO_SESSION_ONE_INTRO_PROGRESS_BY_PAGE_INDEX;
    }

    getStudyTwoSessionTwoProgressByPageConfig () {
        return this.STUDY_TWO_SESSION_TWO_INTRO_PROGRESS_BY_PAGE_INDEX;
    }

    getStudyTwoSessionOnwardProgressByPageConfig () {
        return this.STUDY_TWO_SESSION_ONWARD_INTRO_PROGRESS_BY_PAGE_INDEX;
    }

    getStudyTwoProcedureIndexToProgressMapping () {
        return this.STUDY_TWO_PROCEDURE_INDEX_TO_PROGRESS_MAPPING;
    }

    getStudyTwoSummaryProgressIndexToProgressMapping () {
        return this.STUDY_TWO_SUMMARY_PROGRESS_BY_PAGE_INDEX;
    }
}

export default StudyProgressConfig;
